import React from 'react';
import PropTypes from 'prop-types';
import { v1 as uuid } from 'uuid';
import Item, { propTypes as itemComponentPropTypes } from './Item';
import { StyledHeader } from './Styles';

export const propTypes = {
  // Title used for the group of selectable list.
  headline: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.number
  ]),
  testId: PropTypes.string,
  // A function called when any of the child items is selected
  onClick: PropTypes.func,
  // Array of assets that will be displayed right as a list
  items: PropTypes.arrayOf(itemComponentPropTypes.item)
};

const defaultProps = {
  headline: undefined,
  testId: undefined,
  onClick: undefined,
  items: []
};

const Group = ({ headline, testId, items, onClick }) => {
  const onClickHandler = index => (event, itemSelected) => {
    event.preventDefault();
    event.persist();
    onClick(event, itemSelected, index);
  };
  return (
    <div data-testid={testId}>
      {headline && (
        <StyledHeader data-testid={`${testId}-header`}>{headline}</StyledHeader>
      )}
      {items.map((item, index) => (
        <Item
          key={uuid()}
          item={item}
          index={index}
          onClick={onClick ? onClickHandler(index) : undefined}
          parentTestId={testId}
        />
      ))}
    </div>
  );
};

Group.propTypes = propTypes;
Group.defaultProps = defaultProps;

export default Group;
